(function( $ ) {
    'use strict';

    $( window ).load(function() {

        // enable subscription management buttons and bind reactivate handler globally
        // (journey page, subscriptions page, etc.)
        $('.button-reactivate-subscription').removeAttr("disabled");

        $(".button-reactivate-subscription").click(async function () {
            const subId = $(this).data("subscription-id")
            window.utils.animations.addLoadingSpinner(document.querySelector('body'))
            const responseJson = await window.utils.request.post(`/wp-json/klira/subscription/${subId}/reactivate`)

            let responseObj = JSON.parse(responseJson)
            if (responseObj.success) {
                location.reload()
            } else {
                console.error(responseObj);
                window.utils.forms.addErrorMessage('Could not reactivate subscription, please try again or contact dermteam@klira.skin', this);
                window.utils.animations.removeLoadingSpinner(document.querySelector('body'))
            }
        })

    });
})( jQuery );
